import React, { Component } from "react";
import Hashtag from "../categories/hashtag";
import Recommendation from "./recommendation";
import RecommendationCreate from "./recommendation_create";

class HashtagRecommendations extends Component {
  state = {};
  render() {
    const self = this;
    var recommendations = this.props.hashtag.recommendations.map(function(
      recommendation
    ) {
      return (
        <Recommendation
          recommendation={recommendation}
          key={recommendation.id}
          username={self.props.username}
        />
      );
    });

    return (
      <div>
        <Hashtag
          hashtag={this.props.hashtag.name}
          recommendation_number={this.props.hashtag.recommendation_number}
          username={this.props.username}
        />
        <div className="row recommendation_row">
          {recommendations}
          {this.renderCreateRecommendation()}
        </div>
      </div>
    );
  }

  renderCreateRecommendation() {
    if (this.props.me) {
      return <RecommendationCreate hashtag={this.props.hashtag.name} />;
    }
  }
}

export default HashtagRecommendations;



// WEBPACK FOOTER //
// ./src/components/recommendation/hashtag_recommendation.jsx